<h1 mat-dialog-title>Game Options</h1>
<br/>
<div mat-dialog-content>
  <div><mat-checkbox [(ngModel)]="options.isEasyMode">Easy mode</mat-checkbox></div>
</div>
<br/><br/>
<div>
  <button mat-raised-button mat-dialog-close>Close</button>
</div>

